type MessageWithPromptScope = {
  prompt_scope?: Record<string, unknown> | null;
};

/** Reward receipts are persisted transcript entries, not incoming chat replies. */
export const isRewardClaimReceipt = (message: MessageWithPromptScope): boolean => (
  message.prompt_scope?.reward_claim !== undefined
  && message.prompt_scope.reward_claim !== null
);
